import { BaseApi } from '@/main/baseApi';

import { NAME, DMS_MODULE, DependentTableNames, OUTSTANING_REVENUE_SERVICE_ORDER, OUTSTANING_REVENUE_PART_SALE_ORDER } from './constants';

class OutstandingRevenueAPIProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case OUTSTANING_REVENUE_SERVICE_ORDER:
				return `/${DMS_MODULE}/OutstandingRevenueGrid/${OUTSTANING_REVENUE_SERVICE_ORDER}Schema`;
			case OUTSTANING_REVENUE_PART_SALE_ORDER:
				return `/${DMS_MODULE}/OutstandingRevenueGrid/${OUTSTANING_REVENUE_PART_SALE_ORDER}Schema`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Schema`;
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case OUTSTANING_REVENUE_SERVICE_ORDER:
				return `/${DMS_MODULE}/OutstandingRevenueGrid/${OUTSTANING_REVENUE_SERVICE_ORDER}Rows`;
			case OUTSTANING_REVENUE_PART_SALE_ORDER:
				return `/${DMS_MODULE}/OutstandingRevenueGrid/${OUTSTANING_REVENUE_PART_SALE_ORDER}Rows`;
			default:
				return `/${this.area}/${this.controller}/${tableName}Rows`;
		}
	}

	async GetOutstandingRevenueReportExcel(params: any, columnSeqServiceOrder: string|null, columnSeqPartsSales: string|null, languageId: any) {
		return this.downloadXlsxReport(`/${DMS_MODULE}/OutstandingRevenueGrid/GetOutstandingRevenueReportExcel?${params}&ColumnSequenceServiceOrder=${columnSeqServiceOrder}&ColumnSequencePartsSale=${columnSeqPartsSales}&languageId=${languageId}`, '');
	}
}
export const apiProvider = new OutstandingRevenueAPIProvider();
